import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MultilineInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      pRef: null,
      outputValue: this.value,
      textareaValue: ''
    };
  },
  watch: {
    outputValue: {
      handler: function handler(val) {
        var tempValue = val || '';
        this.textareaValue = tempValue.split(',').join('\n');
        this.$emit('input', tempValue);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.pRef = _this.$refs.popover;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      var outputText = this.textareaValue.split('\n').join(',');
      this.outputValue = outputText;
      this.pRef.doClose();
      this.$nextTick(function () {
        _this2.$emit('confirm');
      });
    },
    handleClear: function handleClear() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$emit('clear');
      });
    }
  }
};